export const INFO_PAGES_CONFIG = {
  ignoreTrailingSlashInPostsUrls: true,
  infoPagesSidebarSectionId: 2,
};
